import clouds from '@/static/assets/home/bg-clouds-2.png';
import { Box } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import styled, { keyframes } from 'styled-components';

const cloudsAnimationMobile = keyframes`
    from {
        transform: translateX(0%);
    }
    to {
        transform: translateX(-658px);
    }
`;

const cloudsAnimationTablet = keyframes`
    from {
        transform: translateX(0%);
    }
    to {
        transform: translateX(-1271px);
    }
`;

const cloudsAnimationDesktop = keyframes`
    from {
        transform: translateX(0%);
    }
    to {
        transform: translateX(-1451px);
    }
`;

const DURATION = 60;

const Clouds = styled(Box)`
  position: absolute;
  left: 0;
  pointer-events: none;
  z-index: -1;
  width: 100%;
  overflow-x: hidden;

  ${MEDIA_QUERIES.mobile`
        height: 161px;
    `}

  ${MEDIA_QUERIES.tablet`
        height: 311px;
    `}

    ${MEDIA_QUERIES.desktop`
        height: 355px;
    `}

    &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 200vw;
    height: 100%;
    background-image: url(${clouds.src});
    background-repeat: repeat-x;
    background-size: contain;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-duration: ${DURATION}s;
    animation-delay: -${DURATION / 2}s;

    ${MEDIA_QUERIES.mobile`
            animation-name: ${cloudsAnimationMobile};
            min-width: 1000px;
        `}

    ${MEDIA_QUERIES.tablet`
            animation-name: ${cloudsAnimationTablet};
        `}

        ${MEDIA_QUERIES.desktop`
            animation-name: ${cloudsAnimationDesktop};
        `}
  }
`;

export default Clouds;
